import * as signalR from "@microsoft/signalr";
import { SignalrServiceClass } from "./signalr-service";
import { signalrConstants } from "./signalr-constants";
import { SignalRTicketService } from "./signalr-ticket-service";
import { SignalRCRMService } from "./signalr-crm-service";
import { SignalRFormService } from "./signalr-form-service";
import { SignalRCxAppSettingsService } from "./signalr-cxappsettings-service";
import { SignalRBillingService } from "./signalr-billing-service";
import { SignalRProjectService } from "./signalr-project-service";
import { SignalRAuMigrationService } from "./signalr-aumigration-service";
export class SignalrHubManager {
  private _ChatHub: SignalrServiceClass | undefined;
  /** Used when Init() was never called or failed: sends/joins no-op until a real hub exists. */
  private _standbyChatHub: SignalrServiceClass | undefined;
  private static _Instance: SignalrHubManager;

  static get Instance(): SignalrHubManager {
    if (!this._Instance) {
      this._Instance = new SignalrHubManager();
      return this.Instance;
    }
    return this._Instance;
  }

  // bootstrapper call method
  public async Init() {
    try {
      const signlarTicket = new SignalRTicketService();
      const signalrForm = new SignalRFormService();
      const signalrBilling = new SignalRBillingService();
      const signalrProject = new SignalRProjectService();
      const setCxAppBrandingConnectionEvents =
        new SignalRCxAppSettingsService();
      const signlarCRM = new SignalRCRMService();
      const signalrAuMigration = new SignalRAuMigrationService();
      this._ChatHub = new SignalrServiceClass(
        "Chat",
        signalrConstants.chat.negotiateUrl,
        signalrConstants.chat.sendMessage,
        (hubConnection: signalR.HubConnection) => {
          signlarTicket.setTicketConnectionEvents(hubConnection);
          signalrForm.setFormConnectionEvents(hubConnection);
          signalrBilling.setBillingConnectionEvents(hubConnection);
          signalrProject.setProjectConnectionEvents(hubConnection);
          setCxAppBrandingConnectionEvents.setCxAppBrandingConnectionEvents(
            hubConnection,
          );
          signlarCRM.setCRMConnectionEvents(hubConnection);
          signalrAuMigration.setAuMigrationConnectionEvents(hubConnection);
        },
      );
      await this._ChatHub.InitializeSignalr();
    } catch (ex) {
      console.log("Exception: " + ex);
      console.log("Could not create chat hub");
    }
  }

  get ChatHub(): SignalrServiceClass {
    if (this._ChatHub) {
      return this._ChatHub;
    }
    if (!this._standbyChatHub) {
      this._standbyChatHub = new SignalrServiceClass(
        "Chat",
        signalrConstants.chat.negotiateUrl,
        signalrConstants.chat.sendMessage,
        () => {
          /* no connection until Init() replaces _ChatHub */
        },
      );
    }
    return this._standbyChatHub;
  }

  public async JoinGroup(groupName: string) {
    this._ChatHub?.joinSignalrGroup(groupName);
  }
}
